import React from "react";
import "./Ourservice.css";

const Ourservice = () => {
  return (
    <div className="our_serviceses">
      <div className="our_service">
        <div className="service_title">
          <h2>Sourcing</h2>
          <div className="title_sep"></div>
          <div class="indicator">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <p>
          Experienced sourcing teams are constantly on the look out for new
          products. These teams of young. talented and experienced professionals
          are sourcing for specialized factories with vertical set up for All
          possible Products.
        </p>
        <p>
          Raw materials for production are also sourced locally and
          internationally from countries such as China, Hong Kong, Taiwan and
          India.
        </p>
        <p>
          It is insured that raw materials for production are sourced from
          Oekotex certified factories.
        </p>
      </div>
      <div className="our_service">
        <div className="service_title">
          <h2>Development</h2>
          <div className="title_sep"></div>
          <div class="indicator">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <p>
          In-house development teams are precisely focused on new product
          developments using local a. imported materials. The development teams
          keep themselves updated with new and current fashion trends.
        </p>
        <p>
          Besides this we are also developing samples and products as per
          customer’s requirement and specification.
        </p>
        <p>
          It is insured that raw materials for production are sourced from
          Oekotex certified factories.
        </p>
      </div>
      <div className="our_service">
        <div className="service_title">
          <h2>Merchandising</h2>
          <div className="title_sep"></div>
          <div class="indicator">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <p>
          Each team headed and monitored by a Manager– routinely and
          systematically updating, b the customer on the progress and status of
          the order.
        </p>
        <p>
          Daily communication and exchange of information is maintained with the
          customer.
        </p>
        <p>
          Due to different requirement of product range of each customer, the
          merchandising department is on the move to insure proper service to
          the customers.
        </p>
        <p>
          Each customer is assigned with an individual and separate
          merchandising team for follow up of orders. This team comes into
          action from the day of Enquiry till the date of shipment.
        </p>
      </div>
      <div className="our_service">
        <div className="service_title">
          <h2>Production & Quality Control</h2>
          <div className="title_sep"></div>
          <div class="indicator">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>

          </div>
        </div>
        <p>
          Each customer is also provided with selected and separate production
          team (quality controllers). These teams along with the merchandising
          team performs quality check on the merchandise during production.
        </p>
        <p>
          Workmanship and other standards such as rubbing test, shrinkage test,
          color fastness are constantly checked and recorded and analyzed.
        </p>
        <p>
          Immediate corrective measures are taken if any deviations are found.
        </p>
        <p>
          Testings are done strictly with certified test laboratory, such as,
          SGS, BV, Hohenstein, Tuv and any other testing lab as required by the
          customer.
        </p>
      </div>
      <div className="our_service">
        <div className="service_title">
          <h2>Social Compliances</h2>
          <div className="title_sep"></div>
          <div class="indicator">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <p>
         <strong>FASHION 2MORROW</strong>  Gives special emphasis on social compliance as
          such most of our factories are BSCI, WRAP, SEDEX, add Accord Alliance
          etc approved. To maintain this compliance we have our own compliance
          and audit team who makes random checks on factories regarding all
          social compliance and audit.
        </p>
      </div>
      <div className="our_service">
        <div className="service_title">
          <h2>Logistics</h2>
          <div className="title_sep"></div>
          <div class="indicator">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <p></p>
        <p>
          In order to handle all kinds of shipments to our valued customers, we
          are always ready to support customer and negotiate the fastest and
          safest voyage time for all shipments. The customer is regularly
          updated with all relevant info regarding shipments by us.
        </p>
      </div>
    </div>
  );
};

export default Ourservice;
